import { produce } from "immer";
import * as Actions from "pages/Archive/store/archivesActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [], hasMore: true };
const archivesReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_ARCHIVES_SUCCESS: {
      const payload = action.payload;
      const archives = payload.archives;
      const archiveIds = payload.archives.map(archive => archive.id);

      const byId = archives.reduce((obj, archive) => {
        obj[archive.id] = archive;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      draft.allIds = archiveIds;
      draft.hasMore = archiveIds.length >= (payload.perPage || 20);

      break;
    }

    case Actions.FETCH_ARCHIVES_APPEND_SUCCESS: {
      const payload = action.payload;
      const archives = payload.archives;
      const archiveIds = archives.map(archive => archive.id);

      const byId = archives.reduce((obj, archive) => {
        obj[archive.id] = archive;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      const newIds = archiveIds.filter(id => !draft.allIds.includes(id));
      draft.allIds = [...draft.allIds, ...newIds];
      draft.hasMore = archiveIds.length >= (payload.perPage || 20);

      break;
    }
    default:
      return draft;
  }
}, initialState);

export default archivesReducer;
